import React from 'react';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const ReservationList = ({ reservations, showCompleted, setShowCompleted, onSelectReservation }) => {

    // Sort logic: active/pending first (by time), then completed (by end time usually, but here just listed last)
    const activeReservations = reservations
        .filter(r => r.status !== 'completed' && r.status !== 'cancelled')
        .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

    const completedReservations = reservations
        .filter(r => r.status === 'completed')
        .sort((a, b) => new Date(b.endTime || b.startTime) - new Date(a.endTime || a.startTime)); // Newest finished first

    const getStatusClass = (status) => {
        if (status === 'completed') return 'status-completed';
        if (['loading', 'arrived'].includes(status)) return 'status-active';
        return 'status-future';
    };

    const getProgressWidth = (res) => {
        // Mock logic for demo if no real logs yet
        if (res.status === 'completed') return 100;
        if (res.status === 'loading') return 45; // Demo
        return 0;
    };

    const renderCard = (res) => {
        const isCompleted = res.status === 'completed';
        const progress = getProgressWidth(res);
        const startTime = format(new Date(res.startTime), 'HH:mm');
        const endTime = format(new Date(res.endTime), 'HH:mm');

        // Extract short name from transporter name (assuming format "ShortName - FullName" or similar, or just taking first 2 words)
        // Or if there is a 'shortName' field use that. Since we don't know, we'll just try to shorten if it's super long, 
        // or prioritize a 'shortName' property if it existed.
        // User requested "Tedarikçi kısa tanımı". We'll assume the 'transporterName' is all we have. 
        // Let's just try to be smart or use it as is if short.
        // User said: "Rhino Tech Danışmanlık LTD. ŞTİ." -> "Rhinotech" (in image).
        // I will assume for now using the first two words might be safer or just the name. 
        // Let's simply truncate or look for a dash.
        // Actually, let's just use the `transporterName` but maybe truncate it via CSS or JS if needed.
        // User specific request: "kısa tanımı olsun... Plaka yazsın."

        const shortName = res.transporterName ? res.transporterName.split(' ')[0] : 'Firma';

        return (
            <div
                key={res.id}
                className={`res-card ${getStatusClass(res.status)}`}
                onClick={() => onSelectReservation(res)}
            >
                <div className="res-info">
                    {/* Row 1: Short Name & Plate */}
                    <div className="res-header-row">
                        <span className="res-short-name">{shortName}</span>
                        <span className="res-divider">|</span>
                        <span className="res-plate">{res.plate}</span>
                    </div>

                    {/* Row 2: Metrics */}
                    <div className="res-metrics-row">
                        <div className="res-metric-item">
                            <span className="metric-label">Hacim:</span>
                            <span className="metric-value">{res.volume || res.metrics?.volume || '0'} M3</span>
                        </div>
                        <div className="res-metric-item">
                            <span className="metric-label">Ağırlık:</span>
                            <span className="metric-value">{res.weight || res.metrics?.weight || '0'} Kg</span>
                        </div>
                    </div>

                    {/* Progress Bar (Only for active/loading) */}
                    {!isCompleted && res.status === 'loading' && (
                        <div className="res-duration-bar">
                            <div className="res-duration-fill" style={{ width: `${progress}%` }} />
                        </div>
                    )}
                </div>

                <div className="text-right ml-4">
                    <div className="res-time-range">
                        {startTime} - {endTime}
                    </div>
                    <div className="res-total-duration">
                        {(() => {
                            const diff = (new Date(res.endTime) - new Date(res.startTime)) / 60000;
                            // Round up to nearest 20 min slot
                            const slotDuration = Math.ceil(diff / 20) * 20;
                            return slotDuration > 0 ? slotDuration : (res.plannedDuration || 60);
                        })()} dk
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="dock-list-container">
            <div className="reservation-list">
                {activeReservations.length === 0 && (
                    <div className="text-center text-secondary py-8">
                        Aktif rezervasyon yok.
                    </div>
                )}
                {activeReservations.map(renderCard)}
            </div>

            <div className="completed-toggle" onClick={() => setShowCompleted(!showCompleted)}>
                <input
                    type="checkbox"
                    checked={showCompleted}
                    onChange={() => { }}
                    style={{ cursor: 'pointer' }}
                />
                <span>Tamamlananları Göster</span>
            </div>

            {showCompleted && (
                <div className="reservation-list mt-4">
                    {completedReservations.length === 0 && (
                        <div className="text-center text-sm text-secondary">
                            Tamamlanan kayıt yok.
                        </div>
                    )}
                    {completedReservations.map(renderCard)}
                </div>
            )}
        </div>
    );
};

export default ReservationList;
